import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import axiosInstance, { weburl } from '../../axiosInstance';
 import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import GooglePlaceSelect from './GooglePlaceSelect';
 import { useBlogContext } from '../../fetchdata/BlogContext';
const SignupProcess = ({userData}) => {


    const {dataAuth,getuserData} = useBlogContext();
const [isuserData, setIsUserData] = useState(null);
 
  // ----- MULTI-STEP STATE -----
  const [step, setStep] = useState(1);
  // All form data in one place
  const [form, setForm] = useState({
  });
  
useEffect(() => {
setIsUserData(getuserData);
 if(getuserData){
  setStep(getuserData.step +1);
       setForm({
      ...getuserData,
      id: getuserData._id,
    });
    console.log('getuserData',getuserData)
 }
}, [getuserData]);

 


  // useEffect(() => {
  //   const checkUserToken = () => {

  //     setForm((prevData) => ({
  //     ...prevData,
  //     username: userData?.username,
  //     email: userData?.email,
  //     subDepartments: userData?.subDepartments,
  //     department : userData?.department,
  //     id: userData?._id,
  //   }));

  //   };
  //   checkUserToken();
  // }, [userData]);


     const [filterInputs, setFilterInputs] = React.useState({
    location: "",
    placeId: "",
  });
  
  const handleLocationChange = (selected) => {
    console.log('selectedselectedselected',selected)
    setFilterInputs({
      location: selected?.label || "",
      placeId: selected?.value || "",
      lat: selected?.lat || "",
      lng: selected?.lng || "",
  
    });
  };




  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

      const handleDescriptionChange = (value) => {
    // Update the state with the new value
    setForm((prevData) => ({
      ...prevData,
      about: value,
    }));
  };



  // ---- STEP VALIDATION ----
  const validateStep = (s) => {
    switch (s) {
      case 1:
        if (!form.username?.trim()) return 'First name is required'; 
        return null; 
           case 2:
        if (!form?.gender) return 'Gender is required';
        return null; 
        
      case 7 :
        if (!form.DOB?.trim()) return 'Birthdate is required';

      const dob = new Date(form.DOB);
      const today = new Date();

      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();

      // Adjust age if birthday has not occurred yet this year
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dob.getDate())
      ) {
        age--;
      }

      if (age < 18) return 'You must be at least 18 years old';

      return null;
      
     case 5:
        if (!form?.gender) return 'Gender is required';
        return null; 
        
      default:
        return null;
    }
  };


  
 

  const handleNext = async (mystep) => {

     const err = validateStep(step);
    if (err) {
      toast.error(err);
      return;
    }

    if(mystep){ 
         try {
  
              const payload = {
      ...form,
      location: filterInputs?.location || "",
      lat: filterInputs?.lat || "",
      lng: filterInputs?.lng || "",
    };

     const response =   await toast.promise(
      axiosInstance.post(`/complete-profile/${mystep}`, payload),
      {
        loading: 'Updating account...',
        // success: (res) =>
        //   res?.data?.message || 'Account created successfully',
        error: (err) =>
          err?.response?.data?.message || 'Something went wrong',
      }
      
    )
    const {success } = response.data;

      if(success){
            setStep(prev => prev + 1);
       if(mystep === 10){
        window.location.reload();
       }
     
      }

      console.log(response.data);

    } catch (error) {
      console.error('Error fetching data:', error);
      
    } finally { 
      dataAuth();
    } 
      return;
    }else{
   
    setStep(prev => prev + 1);
    }
   
  };

  const handleBack = () => setStep(prev => Math.max(1, prev - 1));

  // ---- FINAL SUBMIT (Step 3) ----
 const handleSubmitFinal = async (e) => {
  e.preventDefault();

  const err = validateStep(3);
  if (err) return toast.error(err);

  try {
    const payload = {
      ...form,
      location: filterInputs?.location || "",
      lat: filterInputs?.lat || "",
      lng: filterInputs?.lng || "",
    };

  const response =   await toast.promise(
      axiosInstance.post('/complete-profile', payload),
      {
        loading: 'Updating account...',
        success: (res) =>
          res?.data?.message || 'Account created successfully',
        error: (err) =>
          err?.response?.data?.message || 'Something went wrong',
      }
    );

    const {success} = response.data;
    if(success){
        dataAuth();
 
    }
    // optional: redirect or reset state
    // navigate('/login');
 
  } catch (error) {
    // 🔹 No need for toast here (already handled)
    console.error('Signup error', error);
  }
};


     const [data2, setDataNew] = useState([]);
  

    const selectedSubDepartments = form.department
  ? data2
      .filter((item) => form.department.includes(item._id) && item.value)
      .flatMap((item) =>
        item.value.map((sub) => ({
          parent: item.name,
          value: sub,
          label: `${item.name} → ${sub}`
        }))
      )
  : [];

  const fetchData = async () => {
     console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones-department");
       setDataNew(response.data.Department ?? [])
     } catch (error) {
      console.error("Error fetching data:", error);
    }  
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ---- SCREENS ----
  const Step1 = (
    <div className=" rounded-4 border-0 p-4 mx-auto" style={{ maxWidth: 400 }}>
      <div className="w-100">
<button className='btn btn-rounded p-2 rounded-pill bg-dark text-white mb-3 ' style={{aspectRatio:'1/1',width:40}}><i class="ri-close-large-line"></i></button>
      </div>
      <div className="card-body text-center">
        <h5 className="fw-bold mb-2">Can You elaborate on your identity? 😎</h5>
        <p className="text-muted small mb-4">
          It will Display on your Profile and you will not able to change it later
        </p>
 
        <div className="mb-3">
            <label className='text-start w-100 mb-1'> Full Name  <span className='text-danger'>*</span></label>
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            className="form-control shadow-none rounded-3"
            placeholder="First Name"
          />
        </div>
     
        <div className="d-flex gap-2">
          <button type="button" onClick={() => handleNext(1)} className="btn btn-primary w-100 rounded-3 fw-semibold">
            Next  <i className="ri-arrow-right-s-line" /> 
          </button>
        </div>
      </div>
    </div>
  );

   const Step2 = (
   <div
  className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5 text-center"
  style={{ maxWidth: 480 }}
>
  <h4 className="fw-bold mb-2">Be true to yourself ✨</h4>
  <p className="text-muted mb-4">
    Choose the gender that best represents you. Authenticity is key to meaningful
    connections.
  </p>

     {/* Choices */}
    <div className="d-grid gap-3 mb-4 text-start">
      {[
  { label: "Male", value: "1" },
  { label: "Female", value: "2" },
  { label: "Other", value: "0" },
].map((opt) => (
    <label
      key={opt.value}
      className={`border ${
        Number(form.gender) === Number(opt.value)
          ? "bg-secondary text-white shadow-sm"
          : "border-2"
      } rounded-3 py-3 px-3 fw-semibold cursor-pointer`}
      role="button"
      aria-pressed={Number(form.gender) === Number(opt.value)}
    >
      <input
        type="radio"
        name="gender"
        value={opt.value}      // 👈 1, 2, 0
        checked={Number(form.gender) === Number(opt.value)}
        onChange={handleChange}
        className="d-none"
      />
      {opt.label}
    </label>
  ))}
    </div>

    <div className="d-flex gap-2">
          <button type="button" onClick={handleBack} className="btn btn-dark w-50 rounded-3">
           <i className="ri-arrow-left-s-line" />  Back
          </button>
    <button
   onClick={() => handleNext(2)} 
      type="button"
      className="btn btn-primary rounded-3 w-50 "
     >
      Next <i className="ri-arrow-right-s-line ms-1" />
    </button>
     </div>
 </div>

  );

  
const Step3 = (
  <div
    className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5"
    style={{ maxWidth: 680 }}
  >
    <h5 className="fw-bold mb-2">Discover like-minded people 🤝</h5>
    <p className="text-muted mb-4 fs-6">
      Share your interests, passions, and hobbies. We’ll connect you with people
      who share your enthusiasm.
    </p>

    

          <div className="mb-4 col-12 ">
                          <label className="form-label text-dark" htmlFor="department">
                            Category{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            
                            <Select
  isMulti
  options={data2.map((item) => ({
    value: item._id,
    label: item.name,
  }))} 
  placeholder="Select Category"
  className="w-100"
  value={
    form.department && Array.isArray(form.department)
      ? form.department.map((id) => {
          const dep = data2.find((item) => item._id === id);
          return dep ? { value: dep._id, label: dep.name } : null;
        }).filter(Boolean)
      : []
  }
  onChange={(selectedOptions) => {
    const selectedIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];

    // Update department selection
    handleChange({
      target: {
        name: "department",
        value: selectedIds,
      },
    });

    // Reset sub departments when department changes
    handleChange({
      target: {
        name: "subDepartments",
        value: [],
      },
    });
  }}
/>

                            
                          </div>
                        </div>
  
{selectedSubDepartments.length > 0 && (
  
        <div className="mb-4 col-12 "> 
         <label className="form-label text-dark" htmlFor="subDepartments">
                           Sub Category{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
  <Select
    isMulti
    placeholder="Select Sub-Category"
    className="w-100 mt-3"
    options={selectedSubDepartments}
    value={
      form.subDepartments?.map((sub) => {
        const found = selectedSubDepartments.find((item) => item.value === sub);
        return found ? { value: found.value, label: found.label } : null;
      }).filter(Boolean) || []
    }
    onChange={(selectedOptions) => {
      handleChange({
        target: {
          name: "subDepartments",
          value: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
        },
      });
    }}
  />
           </div>
)}
 


    {/* Buttons */}
    <div className="d-flex gap-2">
      <button
        type="button"
        onClick={handleBack}
        className="btn btn-dark w-50 rounded-3"
      >
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
         onClick={() => handleNext(3)} 
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={(!form.subDepartments || form.subDepartments.length === 0) || (!form.department || form.department.length === 0)}
      >
        Next <i className="ri-arrow-right-s-line ms-1" />
      </button>
    </div>
  </div>
); 


  const Step4 = (
  <div
    className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5"
    style={{ maxWidth: 560 }}
  >
    <h5 className="fw-bold mb-2">Find matches nearby 📍</h5>
    <p className="text-muted mb-4 fs-6">
      Select your preferred distance range to discover matches conveniently.
      We'll help you find love close by.
    </p>


   <div className="mb-4 col-12  ">
                          <label className="form-label text-dark" htmlFor="email">
                 {form.location ? 'Change Location': 'Choose Location ' }
                  <span className="text-danger"> ( Required )</span>
               
                           </label>
                           {form.location &&  <p className="small"> <span className="text-success"> Current :</span> {form.location} </p> }
                          <div className="input-group    input-sm">
                           
<GooglePlaceSelect
  value={
    filterInputs.placeId
      ? { label: filterInputs.location, value: filterInputs.placeId , lat : filterInputs.lat,
              lng : filterInputs.lng }
      : null
  }
  onChange={handleLocationChange}
  CLASS="border rounded "
/>
                          </div>
   </div>


    {/* Distance label + live value */}
    <div className="d-flex justify-content-between align-items-center mb-1">
      <label htmlFor="distanceKm" className="fw-semibold mb-0">
        Distance Preference
      </label>
      <div className="fw-semibold">
        {Number(form.distanceKm ?? 10).toFixed(1)} km
      </div>
    </div>

    {/* Slider */}
    <input
      id="distanceKm"
      type="range"
      name="distanceKm"
      min="1"
      max="50"
      step="0.5"
      value={form.distanceKm ?? 10}
      onChange={handleChange}   // your generic handler is fine
      className="form-range accent-primary mb-4"
      aria-label="Distance Preference"
    />

    {/* Buttons */}
    <div className="d-flex gap-2">
      <button
        type="button"
        onClick={handleBack}
        className="btn btn-dark w-50 rounded-3"
      >
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
        // onClick={handleSubmitFinal}
 onClick={() => handleNext(4)} 
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={!filterInputs.location || !filterInputs.lat || !filterInputs.lng }
      >
       Next
      </button>
    </div>
  </div>
);

const Step5 = (
  <div
    className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5"
    style={{ maxWidth: 560 }}
  >
    <h5 className="fw-bold mb-2">Weight preference ⚖️</h5>
    <p className="text-muted mb-4 fs-6">
      Select a comfortable weight range you prefer. This helps us find better matches.
    </p>

    {/* Weight range labels */}
    <div className="d-flex justify-content-between align-items-center mb-1">
      <label className="fw-semibold mb-0">
        Preferred Weight
      </label>
      <div className="fw-semibold">
        {form.weight ?? 0} kg
      </div>
    </div>

    {/* Min weight */}
    <label className="small text-muted"> Weight (kg)</label>
    <input
      type="range"
      name="weight"
      min="30"
      max="150"
      step="1"
      value={form.weight ?? 0}
      onChange={handleChange}
      className="form-range mb-3"
    />

  

    {/* Buttons */}
    <div className="d-flex gap-2">
      <button
        type="button"
        onClick={handleBack}
        className="btn btn-dark w-50 rounded-3"
      >
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
        onClick={() => handleNext(5)}
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={!form.weight}
      >
        Next
      </button>
    </div>
  </div>
);

const Step6 = (
  <div
    className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5"
    style={{ maxWidth: 560 }}
  >
    <h5 className="fw-bold mb-2">Height 📏</h5>
    <p className="text-muted mb-4 fs-6">
      Enter your height in centimeters.
    </p>

    {/* Height display */}
    <div className="d-flex justify-content-between align-items-center mb-1">
      <label className="fw-semibold mb-0">
        Preferred Height
      </label>
      <div className="fw-semibold">
        {form.minHeight ?? 0} cm 
      </div>
    </div>

    {/* Min height */}
    <label className="small text-muted"> Height (cm)</label>
    <input
      type="number"
      name="minHeight"
      min="120"
      max="220"
      value={form.minHeight ?? ''}
      onChange={handleChange}
      className="form-control mb-3"
      placeholder="e.g. 160"
    />

   
    {/* Buttons */}
    <div className="d-flex gap-2">
      <button
        type="button"
        onClick={handleBack}
        className="btn btn-dark w-50 rounded-3"
      >
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
        onClick={() => handleNext(6)}
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={!form.minHeight}
      >
        Continue
      </button>
    </div>
  </div>
);

  const Step7 = (
    <div className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5 text-center" style={{ maxWidth: 400 }}>
      <h4 className="fw-bold mb-2">Let's celebrate you 🎂</h4>
      <p className="text-muted mb-4">
        Tell us your birthdate. Your profile does not display your birthdate, only your age.
      </p>

         <div className="input-group input-group-md mb-5">
          <input
            type="date"
            name="DOB"
            value={form.DOB}
            onChange={handleChange}
            className="form-control border-2"
            placeholder="DD/MM/YYYY"
          />
        </div>

        <div className="d-flex gap-2">
          <button type="button" onClick={handleBack} className="btn btn-dark w-50 rounded-3">
           <i className="ri-arrow-left-s-line" />  Back
          </button>
      <button type="button"  onClick={() => handleNext(7)} className="btn btn-primary w-50 rounded-3 fw-semibold">
          Next    <i className="ri-arrow-right-s-line" /> 
        </button>
        </div>
     </div>
  );


  
const Step8 = (
  <div className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5" style={{ maxWidth: 560 }}>
    <h5 className="fw-bold mb-2">Introduce yourself ✨</h5>
    <p className="text-muted mb-4 fs-6">
      Write a short intro. Keep it real—what you do, what you like, and what you’re looking for.
    </p>

    <div className="mb-3">
      <label className="form-label fw-semibold">About you <span className="text-danger">*</span></label>
           <ReactQuill
                                                                   value={form.about}
                                                                   onChange={handleDescriptionChange}
                                                                   modules={{
                                                                     toolbar: [
                                                                       [
                                                                         "bold",
                                                                         "italic",
                                                                         "underline",
                                                                         "strike",
                                                                         "blockquote",
                                                                       ],
                                                                       [{ list: "ordered" }, { list: "bullet" }],
                                                                     ],
                                                                   }}
                                                                   formats={[
                                                                     "bold",
                                                                     "italic",
                                                                     "underline",
                                                                     "strike",
                                                                     "blockquote",
                                                                     "list",
                                                                     "bullet",
                                                                   ]}
                                                                   bounds={".app"}
                                                                 />
    </div>

    <div className="d-flex gap-2">
      <button type="button" onClick={handleBack} className="btn btn-dark w-50 rounded-3">
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
        onClick={() => handleNext(8)}
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={!(form.about && form.about.trim().length >= 10)}
      >
        Next
      </button>
    </div>
  </div>
);

const Step9 = (
  <div className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5" style={{ maxWidth: 560 }}>
    <h5 className="fw-bold mb-2">Add your email 📩</h5>
    <p className="text-muted mb-4 fs-6">
      We’ll use this for account important updates.
    </p>

    <div className="mb-4">
      <label className="form-label fw-semibold">Email Address <span className="text-danger">*</span></label>
      <input
        type="email"
        name="email"
        value={form.email ?? ""}
        onChange={handleChange}
        className="form-control"
        placeholder="example@gmail.com"
      />
      <small className="text-muted">We never share your email publicly.</small>
    </div>

    <div className="d-flex gap-2">
      <button type="button" onClick={handleBack} className="btn btn-dark w-50 rounded-3">
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
        onClick={() => handleNext(9)}
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={!form.email || !/^\S+@\S+\.\S+$/.test(form.email)}
      >
        Next
      </button>
    </div>
  </div>
);

const docKeys = [
  "Doc1","Doc2","Doc3","Doc4","Doc5",
  "Doc6","Doc7","Doc8","Doc9","Doc10"
];

  
const Step10 = (
  <div className="mx-auto bg-white shadow-lg rounded-4 p-4 p-md-5" style={{ maxWidth: 560 }}>
    <h5 className="fw-bold mb-2">Add photos 📸</h5>
    <p className="text-muted mb-4 fs-6">
      Upload a clear profile photo and a few gallery photos to get better matches.
    </p>

    {/* Profile Image */}
    <div className="mb-4">
      <label className="form-label fw-semibold">
        Profile Photo <span className="text-danger">*</span>
      </label>

                            <div className="mb-4 col-12 col-md-6">
                                                                        
                                             
                                                                       <div className="openimage-container">
                                               {form.profile && typeof form.profile === "string" ? (
                                                 <img
                                                   src={form.profile !== "" ? weburl + form.profile : "/img/profile-default.png"}
                                                   id="ProfileImage"
                                                   alt="Profile Image"
                                                   style={{
                                                     width: "100%",
                                                     aspectRatio: "1/1",
                                                     background: "#f8f9fa",
                                                     display: "block",
                                                     textAlign: "center",
                                                     lineHeight: "40vh",
                                                     borderRadius: "",
                                                     objectFit: "cover",
                                                     border: "1px solid grey",
                                                   }}
                                                 />
                                               ) : (
                                                 <img
                                                   src={form.profile && typeof form.profile === "string" && form.profile !== "" 
                                                     ? weburl + form.profile 
                                                     : "/img/profile-default.png"}
                                                   id="ProfileImage"
                                                   alt="Profile Image"
                                                   style={{
                                                     width: "100%",
                                                     aspectRatio: "1/1",
                                                     background: "#f8f9fa",
                                                     display: "block",
                                                     textAlign: "center",
                                                     lineHeight: "40vh",
                                                     borderRadius: "",
                                                     objectFit: "cover",
                                                     border: "1px solid grey",
                                                   }}
                                                 />
                                               )}
                                               <input
                                                 type="file"
                                                 id="profileImage"
                                                 className="form-control"
                                                 name="profileImage"
                                                 accept=".jpg, .jpeg, .png, .webp"
                                                 onChange={(event) => {
                                                   const file = event.target.files[0];
                                                   if (file) {
                                                     const reader = new FileReader();
                                                     reader.onload = (e) => {
                                                       const imgElement = document.getElementById("ProfileImage");
                                                       if (imgElement) {
                                                         imgElement.src = e.target.result; // Set the image URL directly on the img element
                                                       }
                                                     };
                                                     reader.readAsDataURL(file); // Read the file as a data URL
                                                     setForm((prevData) => ({ ...prevData, profile: file })); // Update profile in state
                                                   }
                                                 }}
                                               />
                                             </div>
                                             
                                                                     </div>
                                           
       
                                 


    </div>

    {/* Gallery Images */}
    <div className="mb-4">
      <label className="form-label fw-semibold">Gallery Photos (up to 6)</label>

<div className='row'>

              {docKeys.map((docKey, index) => (
                                               <div className="mb-4 col-6 col-md-6">
                                                                       <label className="form-label text-dark" htmlFor="profileImage">
                                                                        Image {index+1}
                                                                         <span className="text-danger"> *</span>
                                                                       </label>
       
         <div className="openimage-container" key={index}>
           <img
             src={
               form[docKey] && typeof form[docKey] === "string"
                 ? weburl + form[docKey]
                 : "/img/profile-default.png"
             }
             id={`ProfileImage-${docKey}`}
             alt={`${docKey} Image`}
             style={{
               width: "100%",
               aspectRatio: "1/1",
               background: "#f8f9fa",
               display: "block",
               objectFit: "cover",
               border: "1px solid grey",
             }}
           />
       
           <input
             type="file"
             className="form-control"
             accept=".jpg, .jpeg, .png, .webp"
             onChange={(event) => {
               const file = event.target.files[0];
               if (!file) return;
       
               const reader = new FileReader();
               reader.onload = (e) => {
                 const img = document.getElementById(`ProfileImage-${docKey}`);
                 if (img) img.src = e.target.result;
               };
               reader.readAsDataURL(file);
       
               setForm((prev) => ({
                 ...prev,
                 [docKey]: file,
               }));
             }}
           />
         </div>
           </div>
       ))}
         
</div>

    </div>

    {/* Buttons */}
    <div className="d-flex gap-2">
      <button type="button" onClick={handleBack} className="btn btn-dark w-50 rounded-3">
        <i className="ri-arrow-left-s-line" /> Back
      </button>

      <button
        type="button"
        onClick={() => handleNext(10)} // or final submit
        className="btn btn-primary w-50 rounded-3 fw-semibold"
        disabled={!form.profile}
      >
        Finish
      </button>
    </div>
  </div>
);



  return (
     <div className="container pt-50 pb-50 d-flex justify-content-center align-items-center " style={{minHeight:'90vh'}}>
      
      <div>
        <div className="progress mb-4" style={{height:10}}>
  <div
    className="progress-bar bg-success"
    role="progressbar"
    style={{ width: step === 1 && '10%' || step === 2 && '20%' || step === 3 && '30%' ||
       step === 4 && '40%' || step === 4 && '50%' || step === 5 && '50%' || step === 6 && '60%' || step === 7 && '70%'  || step === 8 && '80%'
         || step === 9 && '90%' || step === 10 && '100%' }} 
    aria-valuenow={25}
    aria-valuemin={0}
    aria-valuemax={100}
  />
</div>

{step === 1 && Step1}
        {step === 2 && Step2}
         {step === 3 && Step3}
           {step === 4 && Step4}
            {step === 5 && Step5} 
            {step === 6 && Step6} 
            {step === 7 && Step7} 
              {step === 8 && Step8} 
            {step === 9 && Step9} 
                {step === 10 && Step10} 
                                {step === 11 && Step10} 

         </div>  
 
      </div>
  )
}

export default SignupProcess